import copy from 'copy-to-clipboard';

common.View.create('shop::order.createEdit.Address', {

	/**
	 * Called when DOM is ready.
	 */
	onDOMLoad()
	{
		this.initCopy();
	},

	initCopy()
	{
		this.element

			.find('button[name="copy"]')
			.click(this.copy.bind(this))
			.end();
	},

	copy()
	{
		//
		copy(this.getCopyData());

		// Notify
		window.vueApp.$toasted.show('<i class="fa fa-copy"></i> Het adres is gekopieerd.', {type: 'info'});
	},

	getCopyData()
	{
		let lines = [];

		this.element

			// Loop root levels.
			.find('.card-sub > *')
			.filter('*[class*=".galaxy\\:\\:common-form-inputs-"], .form-group')
			.each((i, element) =>
			{
				// Get value(s).
				let values = [];

				for (let input of $(element).find('input, select'))
					values.push($(input).val());

				// Add concatenated to lines.
				lines.push(values.filter(Boolean).join(' '));
			})
			.end();

		// Glue with breaks.
		return lines.filter(Boolean).join("\n");
	},

});
